export function getUser() {
  try {
    return JSON.parse(sessionStorage.getItem('user') || 'null');
  } catch (_error) {
    return null;
  }
}

export function setSession(token, user) {
  sessionStorage.setItem('accessToken', token);
  sessionStorage.setItem('user', JSON.stringify(user));
}

export function clearSession() {
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('user');
}

export function isLoggedIn() {
  return Boolean(sessionStorage.getItem('accessToken'));
}

